import { Injectable, Injector } from '@angular/core';
import { environment } from '../../../environments/environment';
import { XhrDetailsService } from './xhr-details.service';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import * as uuid from 'uuid'

interface XhrOptions {
  method: string;
  url: string;
  data?: any;
  headers?: Record<string, string>;
  success?: (response: any) => void;
  error?: (err: any) => void;
}

export interface IPayload{
    session_key: string;
    unique_key: string;
    source_site: string;
    host_site: string;
    event_type: string;
    error_error: any;
    error_name: string | number;
    error_message: string;
    error_stack: string;
    error_url: string;
    environment: string;
    build: string;
    user_agent: any;
    user_language: any;
    lastXHR: any;
 }

@Injectable({
  providedIn: 'root'
})
export class SplunkService {
  private readonly SPLUNK_URL = environment.splunkLoggerUrl;
  private readonly SPLUNK_AUTH_KEY = environment.splunkLoggerAuthValue;
  private xhrDetailService: XhrDetailsService;
  private location: LocationStrategy;
  private pathUrl: string;
  private XhrDetails: any[];

  constructor(private injector: Injector) { 
    this.location = this.injector.get(LocationStrategy);
    this.xhrDetailService = this.injector.get(XhrDetailsService);
    this.pathUrl = this.location instanceof PathLocationStrategy ? this.location.path() : '';
    this.XhrDetails = this.xhrDetailService.getMostRecentXHRs();
  }

  logger(payload: IPayload, error: any): void {
    try {
      if (window.location.hostname !== 'localhost') {
        this.send(payload);
      }
      else {
        console.error(error);
      }
    } catch (splunkError: any) {
      console.error(splunkError);
      console.error(error);
    }
  }

  generatePayload(s: Partial<IPayload>): IPayload {
    return {
      session_key: s.session_key || '',
      unique_key: s.unique_key || uuid.v4(),
      source_site: s.source_site || '',
      host_site: s.host_site || window.location.hostname,
      event_type: s.event_type || '',
      error_error: s.error_error || '',
      error_name: s.error_name || '',
      error_message: s.error_message || '',
      error_stack: s.error_stack || '',
      error_url: s.error_url || this.pathUrl,
      environment: s.environment || environment.environmentName,
      build: s.build || environment.buildInfo,
      user_agent: s.user_agent || window.navigator.userAgent,
      user_language: s.user_language || window.navigator.language,
      lastXHR: s.lastXHR || this.XhrDetails
    };
  }

  send(data: IPayload, splunkKey?: string): Promise<unknown> {
    return new Promise((resolve, reject) =>
      this.xhr({
        method: 'POST',
        url: this.SPLUNK_URL,
        data: typeof data === 'string' ? data : JSON.stringify({ event: data }),
        headers: {
          Authorization: `Splunk ${this.SPLUNK_AUTH_KEY || splunkKey}`
        },
        success: () => { /* empty */ },
        error: () => { /* empty */ }
      })
    );
  }

  private xhr({ method, url, data, headers, success, error }: XhrOptions): void {
    fetch(url, {
      method,
      headers: new Headers(headers),
      mode: 'cors',
      redirect: 'error',
      cache: 'no-cache',
      body: data
    }).then(success).catch(error);
  }
}
